import React, { useState } from 'react';
import axios from 'axios';

const Register = () => {
  const [fullname, SetFullname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState('');
  const [role, setRole] = useState('item_user');
  const [error, setError] = useState('');

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await registerUser({ fullname, email, password });
  //     onRegister(response.data.token);
  //   } catch (error) {
  //     console.error('Registration failed:', error);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const response = await axios.post('http://localhost:5000/api/auth/register', {
        // const response = await axios.post('https://erp-server-3qrl.onrender.com/api/auth/register', {
            fullname,
            phone,
            email,
            password,
            role,
            company
        });

        // console.log('Registration response:', response.data); // Log the response

        if (response.data.token) {
            localStorage.setItem('token', response.data.token); // Save token to localStorage
            // navigate('/dashboard'); // Redirect to home page
            window.location.href = '/dashboard'; // Force complete page reload and redirect
          } else {
            console.error('No token received:', response.data);
        }
    } catch (err) {
        setError(err.response.data.message);
        // console.error('Registration failed:', err.response ? err.response.data : err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto mt-10">
      {error && (
        <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 mb-2" role="alert">
          <p>{error}</p>
        </div>
      )}

      <h2 className="text-2xl font-bold mb-5">Register</h2>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Name</label>
        <input
          type="text"
          value={fullname}
          onChange={(e) => SetFullname(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Phone</label>
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Company</label>
        <input
          type="text"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className='block text-sm font-medium mb-2' htmlFor="role">Role</label>
        <select value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="item_user">Item User</option>
          <option value="admin_user">Admin User</option>
          {/* <option value="super_admin">Super Admin</option> */}
        </select>
      </div>

      <button type="submit" className="w-full bg-green-500 text-white p-2 rounded">
        Register
      </button>
    </form>
  );
};

export default Register;